/* Line canlı sayfalar (#bx) — ürün grubu düzeni (2026-10-12, Kenan):
   - Grup kaydırmalı/uzun liste DEĞİL: ekrana sığan tek satır gösterilir (mobil 2, tablet 3, masaüstü 4 ürün).
   - Altında "Visa alla (N st) →" → o grubun TÜM ürünleri (diğer gruplar gizlenir, adres ?visa=<grup>).
   - Grup görünümünde en altta "← Tillbaka till <sayfa>" → sayfanın genel görünümüne (o gruba) döner.
   Kaynak: Line2026/Store-Tech/theme_live_pages/assets/line-live-visa.js */
(function(){
  var root=document.getElementById('bx'); if(!root) return;
  var mqS=window.matchMedia('(max-width:700px)'), mqM=window.matchMedia('(max-width:1024px)');
  function cols(){ return mqS.matches?2:(mqM.matches?3:4); }
  var page=(document.title||'').split(/\s[–|-]\s/)[0].trim()||'sidan';
  function gals(){ return [].slice.call(root.querySelectorAll('.bx-gal')); }
  function cur(){ try{ return new URL(location.href).searchParams.get('visa')||''; }catch(e){ return ''; } }
  function el(tag,cls,html){ var e=document.createElement(tag); e.className=cls; if(html!=null) e.innerHTML=html; return e; }
  var busy=false;
  function setH(e,h){ if(e._h!==h){ e._h=h; e.innerHTML=h; } }
  function apply(){
    if(busy) return; busy=true;
    var v=cur(), n=cols(), hit=false;
    gals().forEach(function(s){
      var g=s.querySelector('.bx-grid'); if(!g) return;
      var id=s.id.replace(/^bx-/,''), cs=[].slice.call(g.querySelectorAll('.bx-card')), on=(v===id);
      if(on) hit=true;
      s.classList.toggle('bx-visa-on',on);
      s.classList.toggle('bx-visa-off',!!v&&!on);
      cs.forEach(function(c,i){ c.classList.toggle('bx-visa-hide',!on&&i>=n); });
      var more=s.querySelector('.bx-visa-more');
      if(!more){ more=el('div','bx-visa-more'); more.hidden=true; g.parentNode.insertBefore(more,g.nextSibling); }
      more.hidden=on||cs.length<=n;
      var ext=s.getAttribute('data-ext');
      if(!more.hidden) setH(more, ext ? '<a class="bx-visa-btn" href="'+ext+'">Visa hela kollektionen ('+cs.length+' st) →</a>' : '<a class="bx-visa-btn" href="?visa='+encodeURIComponent(id)+'" data-visa="'+id+'">Visa alla ('+cs.length+' st) →</a>');
      var back=s.querySelector('.bx-visa-back');
      if(!back){ back=el('div','bx-visa-back'); back.hidden=true; s.appendChild(back); }
      back.hidden=!on;
      if(on) setH(back,'<a class="bx-visa-btn bx-visa-ret" href="'+location.pathname+'#'+s.id+'" data-visa-back="'+s.id+'">← Tillbaka till '+page.replace(/[<>&]/g,'')+'</a>');
    });
    root.classList.toggle('bx-visa-mode',!!v&&hit);
    busy=false;
  }
  // Kaydırma: tema html{scroll-behavior:smooth} kullanıyor; sayfa boyu değişirken yumuşak kaydırma yarıda kalıp sayfayı alta (footer) bırakıyordu.
  // Bu yüzden anlık ('instant') kaydır + görseller yerleşince tekrar düzelt (kullanıcı bu arada kaydırmadıysa).
  function off(){ var h=document.querySelector('.section-header'), c=root.querySelector('.bx-chips'); return (h?h.offsetHeight:0)+(c?c.offsetHeight:0)+12; }
  function jump(el){
    if(!el) return;
    var y=function(){ return Math.max(0,Math.round(el.getBoundingClientRect().top+window.pageYOffset-off())); };
    var last=y(); window.scrollTo({top:last,behavior:'instant'});
    [120,400,900].forEach(function(ms){ setTimeout(function(){ if(Math.abs(window.pageYOffset-last)>4) return; last=y(); window.scrollTo({top:last,behavior:'instant'}); },ms); });
  }
  function go(id,anchor){
    var u=new URL(location.href); u.hash='';
    if(id) u.searchParams.set('visa',id); else u.searchParams.delete('visa');
    history.pushState({visa:id||''},'',u.pathname+u.search+(anchor?'#'+anchor:''));
    apply();
    jump(id?document.getElementById('bx-'+id):(anchor?document.getElementById(anchor):null));
  }
  root.addEventListener('click',function(e){
    var a=e.target.closest('[data-visa],[data-visa-back]'); if(!a) return;
    e.preventDefault();
    if(a.hasAttribute('data-visa')) go(a.getAttribute('data-visa'));
    else go('',a.getAttribute('data-visa-back'));
  });
  // kategori kutusu tıklanınca grup görünümündeysek genel görünüme dön
  root.addEventListener('click',function(e){
    var a=e.target.closest('a[href^="#bx-"]'); if(!a||!cur()) return;
    var u=new URL(location.href); u.searchParams.delete('visa'); history.replaceState(null,'',u.pathname+u.search+location.hash); apply();
  },true);
  window.addEventListener('popstate',function(){ apply(); var v=cur(); jump(v?document.getElementById('bx-'+v):(location.hash?document.querySelector(location.hash):null)); });
  [mqS,mqM].forEach(function(m){ if(m.addEventListener) m.addEventListener('change',apply); else if(m.addListener) m.addListener(apply); });
  // 250+ ürün: line-live-bx.js sonradan kart ekler → yeniden uygula
  var t0=null; new MutationObserver(function(){ if(busy) return; clearTimeout(t0); t0=setTimeout(apply,60); }).observe(root,{childList:true,subtree:true});
  apply();
  if(cur()) setTimeout(function(){ jump(document.getElementById('bx-'+cur())); },150);
})();
